import { createContext } from "react"

export type Issue = {
    projectId: number
    issueId: number
    workstream: string
    workstreamId: number
    workPackage: string
    workPackageId: number
    description: string
    resolution: string
    rating: "Low" | "Medium" | "High"
    status: "Closed" | "Cancelled" | "Open"
    date: Date
    raisedBy: string
    owner: string
    userId: string
    notes: string
    displayOnDashboard: boolean
    displayOnStatusReport: boolean
    seen: boolean
    acknowledged: boolean
}

interface IssueContextProps {
    dialogOpen: boolean;
    setDialogOpen: (open: boolean) => void;
    issueTableDemoContent: Issue[];
    setIssueTableDemoContent: (content: Issue[]) => void;
    showPopup: (issue: Issue) => void;
    demoMode: boolean;
    setDemoMode: (mode: boolean) => void;
    rowSelection: {};
    setRowSelection: React.Dispatch<React.SetStateAction<{}>>;
    addIssue: () => void;
}

export const IssueContext = createContext<IssueContextProps>({
    dialogOpen: false,
    setDialogOpen: () => {},
    issueTableDemoContent: [],
    setIssueTableDemoContent: () => {},
    showPopup: () => {},
    demoMode: false,
    setDemoMode: () => {},
    rowSelection: {},
    setRowSelection: () => {},
    addIssue: () => {},
});